// ─── Breeds ───────────────────────────────────────────────
export const DOG_BREEDS = [
  "Aspin","Labrador Retriever","Golden Retriever","German Shepherd","Poodle",
  "Bulldog","Chihuahua","Siberian Husky","Beagle","Shih Tzu","Maltese",
  "Pomeranian","Dachshund","Rottweiler","Schnauzer","Chow Chow","Border Collie",
  "Yorkshire Terrier","Boxer","Other",
];
export const CAT_BREEDS = [
  "Puspin","Persian","Siamese","Maine Coon","British Shorthair","Ragdoll",
  "Bengal","Scottish Fold","Russian Blue","Abyssinian","Birman","Other",
];

// ─── Grooming Services ────────────────────────────────────
export const GROOMING_SERVICES = {
  dog: [
    { id:"basic_grooming", name:"Basic Grooming", desc:"Bath, blow dry, brush, nail trim",
      sizes:[
        { label: "Small (Single Coated)", price: 400 },
        { label: "Medium (Single Coated)", price: 500 },
        { label: "Large (Double Coated)", price: 650 },
        { label: "Extra Large (Triple Coated)", price: 850 }
      ] },
    { id:"full_grooming", name:"Full Grooming", desc:"Basic + haircut & styling",
      sizes:[
        { label: "Small (Single Coated)", price: 500 },
        { label: "Medium (Single Coated)", price: 600 },
        { label: "Large (Double Coated)", price: 750 },
        { label: "Extra Large (Triple Coated)", price: 950 }
      ] },
  ],
  cat: [
    { id:"cat_grooming", name:"Cat Grooming", desc:"Full cat grooming service", price:600 },
  ],
  addons: [
    { id:"nail_trim",      name:"Nail Trim",      price:100 },
    { id:"teeth_brushing", name:"Teeth Brushing", price:100 },
    { id:"eye_wash",       name:"Eye Wash",       price:100 },
    { id:"ear_cleaning",   name:"Ear Cleaning",   price:100 },
    { id:"anal_drain",     name:"Anal Drain",     price:180 },
  ],
};

// ─── Hotel Rooms ──────────────────────────────────────────
export const HOTEL_ROOMS = [
  { id:"dog_small",       name:"Dog Room Small",  price:500, capacity:6, icon:"🐕", desc:"Cozy room for small & medium dogs", category: "dog" },
  { id:"dog_large",       name:"Dog Room Large",  price:800, capacity:2, icon:"🐩", desc:"Spacious room for large dogs", category: "dog" },
  { id:"cat_villa_small", name:"Cat Villa Small", price:500, capacity:4, icon:"🐈", desc:"Cozy private villa for cats", category: "cat" },
  { id:"cat_villa_large", name:"Cat Villa Large", price:800, capacity:2, icon:"🐱", desc:"Spacious luxury villa for cats", category: "cat" },
];

// ─── Time Slots ───────────────────────────────────────────
export const GROOMING_TIMES_1HR = [
  "09:00 AM","10:00 AM","11:00 AM","01:00 PM","02:00 PM","03:00 PM","04:00 PM",
];
export const GROOMING_TIMES_2HR = [
  "09:00 AM","11:00 AM","01:00 PM","03:00 PM",
];
export const GROOMING_TIMES = GROOMING_TIMES_1HR;
export const HOTEL_CHECKIN_TIMES = [
  "09:00 AM","10:00 AM","11:00 AM",
  "12:00 PM","01:00 PM","02:00 PM","03:00 PM","04:00 PM","05:00 PM","06:00 PM","07:00 PM"
];
export const HOTEL_CHECKOUT_TIMES = ["10:00 AM","12:00 PM","02:00 PM"];

// ─── Haircut Styles ───────────────────────────────────────
export const DOG_STYLES = [
  "Puppy Cut","Teddy Bear Cut","Lion Cut","Summer Cut","Natural Trim","Breed-Specific Cut","Custom",
];
export const CAT_STYLES = ["Lion Cut","Summer Cut","Comb Cut","Natural Trim","Custom"];

// ─── Style Image Mapping ──────────────────────────────────
export const STYLE_IMAGES = {
  dog: {
    "Puppy Cut": "/images/cuts/puppy_cut.png",
    "Teddy Bear Cut": "/images/cuts/teddy_bear_cut.png",
    "Lion Cut": "/images/cuts/lion_cut.png",
    "Summer Cut": "/images/cuts/summer_cut.png",
    "Natural Trim": "https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=400&fit=crop",
  },
  cat: {
    "Lion Cut": "/images/cuts/cat_lion_cut.png",
    "Summer Cut": "/images/cuts/cat_summer_cut.png",
    "Comb Cut": "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=400&fit=crop",
    "Natural Trim": "https://images.unsplash.com/photo-1573865526739-10659fec78a5?w=400&fit=crop",
  }
};

// ─── Default Pet Object ───────────────────────────────────
export const newPet = () => ({
  id: Date.now(),
  petName:"", petType:"dog", breed:"", isCustomBreed:false, customBreed:"",
  gender:"unknown", birthday:"", photoUrl:"",
  behaviorNotes:"", vetCard:null,
  serviceType:null,
  groomingService:null, groomingSize:null, groomingAddons:[],
  groomingDate:null, groomingTime:null,
  haircutStyle:null, haircutInstructions:"",
  hotelRoom:null,
  checkInDate:null,  checkInTime:null,
  stayDays:1,        exceedingHours:0,
  checkOutDate:null, checkOutTime:null,
  feedingInstructions:"",
  isVaccinated:null, lastVaccinationDate:"",
  healthStatus:null, medicalConditions:"", medication:"",
});
